import React, { useEffect, useRef, useState } from "react";

import parsePhoneNumber from "libphonenumber-js";
import * as R from "ramda";
import { FormCivil } from "./forms/formCivil";

export const Civil = ({ relocationDeclaration, userId, isLoading }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	let parsedMobilePhoneNumber = undefined;
	if (!relocationDeclaration?.phoneNumber?.startsWith("+00")) {
		parsedMobilePhoneNumber = !R.isNil(relocationDeclaration?.phoneNumber) && relocationDeclaration?.phoneNumber !== "" ? parsePhoneNumber(relocationDeclaration?.phoneNumber).formatInternational() : undefined;
	}

	const [editMode, setEditMode] = useState(false);

	return (
		<section className="card mb-sm">
			{/*  If card is not active replace: 
				1. in card title " text-secondary" with " text-gray"
				2. remove checked from switch
			*/}
			<div className="card-header pb-0">
				<div className="grid grid-sm-2 align-items-center">
					<h2 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">Informations personnelles</h2>
					<div className="grid grid-2 ml-sm-auto align-items-center">
						<button
							type="button"
							className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"
							onClick={() => {
								setEditMode(true);
							}}>
							<i className="eva eva-edit-2-outline align-middle fs-lead"></i>
						</button>
						<div className="custom-control custom-switch mx-auto">
							<input type="checkbox" className="custom-control-input" id="civilSwitchCheckDefault" required="required" defaultChecked={relocationDeclaration?.onBoardingStep > 3} />
							<label className="custom-control-label" htmlFor="civilSwitchCheckDefault">
								Valider
							</label>
						</div>
					</div>
				</div>
				<hr className="mb-0" />
			</div>
			{!editMode ? (
				<div className="card-body flex-row col-10 justify-content-between g-2">
					<div className="block">
						<h3 className="h6 font-weight-bold">Nom</h3>
						<p className="h5">{relocationDeclaration?.lastName}</p>
					</div>
					<div className="block">
						<h3 className="h6 font-weight-bold">Prénom</h3>
						<p className="h5">{relocationDeclaration?.firstName}</p>
					</div>
					<div className="block">
						<h3 className="h6 font-weight-bold">Email</h3>
						<p className="h5">{relocationDeclaration?.email}</p>
					</div>
					{R.isNil(parsedMobilePhoneNumber) ? (
						<div className="block">
							<h3 className="h6 font-weight-bold">Téléphone</h3>
							<p className="h5">{relocationDeclaration?.phoneNumber === "" ? "N/D" : relocationDeclaration?.phoneNumber}</p>
						</div>
					) : (
						<div className="block">
							<h3 className="h6 font-weight-bold">Mobile</h3>
							<p className="h5">{parsedMobilePhoneNumber}</p>
						</div>
					)}
				</div>
			) : (
				<FormCivil relocationDeclaration={relocationDeclaration} userId={userId} isLoading={isLoading} setEditMode={setEditMode} />
			)}
		</section>
	);
};
